export enum PermissionLevel {
  Basic = 'basic',
  Admin = 'admin',
}

export const permissionLevels = Object.entries(PermissionLevel)
  .filter(([key, _]) => Number.isNaN(Number(key)))
  .map(([key, _]) => ({ label: key, value: key.toLowerCase() }))
